/* eslint-disable */
export interface MentionData {
  /** The mentioned user's name. */
  name: string;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug: string;
  /** Mentioned user's ID. */
  id?: string;
}

const baseMentionData: object = { name: "", slug: "" };

export const MentionData = {
  fromJSON(object: any): MentionData {
    const message = { ...baseMentionData } as MentionData;
    message.name =
      object.name !== undefined && object.name !== null
        ? String(object.name)
        : "";
    message.slug =
      object.slug !== undefined && object.slug !== null
        ? String(object.slug)
        : "";
    message.id =
      object.id !== undefined && object.id !== null
        ? String(object.id)
        : undefined;
    return message;
  },

  toJSON(message: MentionData): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.slug !== undefined && (obj.slug = message.slug);
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },
};
